<div class="center">
    <div class="_block _input cursor-pointer d-inline-flex justify-content-between">
        <i class="mdi mdi-star" *ngFor="let i of [5,4,3,2,1]" [class.muted]="value < i" [style.order]="i - 5" (click)="!readonly ? emitValue(i) : {}"></i>
    </div>
</div>